import { React } from "react";
import Header from "../../../components/common/header";
import Sidenav from "../../../components/common/sidenav";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";

const { Content } = Layout;

const Mainpage = () => {
  return (
    <Layout className="h-screen bg-primaryColor">
      <Sidenav />
      <Layout style={{ minHeight: "100vh" }}>
        <Header />
        <Content className="w-full overflow-auto">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Mainpage;
